import List from '../../../components/People/PayrollClaim/List'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function PayrollClaim(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/people">People</Breadcrumb.Item>
              <Breadcrumb.Item>PayrollClaim</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle title={'PayrollClaim'} subtitle={'PayrollClaim'} color={'#FF6138'} iconType={'money-collect'} />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

PayrollClaim.propTypes = {}
PayrollClaim.defaultProps = {}

export default PayrollClaim
